//import $ from "jquery";
import L from "leaflet";
import flatpickr from "flatpickr";

//import "port-validate-unobtrusive";
import "leaflet/dist/leaflet.css";
import "flatpickr/dist/flatpickr.min.css";

export function initRiverDepthForecasting(options = {}) {
    const {
        mapElementId = "map"
    } = options;

    function initMap() {
        const mapElement = document.getElementById(mapElementId);

        if (!mapElement) {
            return;
        }

        const geojsonFeature = [
            {
                type: "Feature",
                properties: { popupContent: "1. Tongue Point" },
                geometry: { type: "Point", coordinates: [46.246554, -123.759444] }
            },
            {
                type: "Feature",
                properties: { popupContent: "2. Skamokawa" },
                geometry: { type: "Point", coordinates: [46.281156, -123.466622] }
            },
            {
                type: "Feature",
                properties: { popupContent: "3. Wauna" },
                geometry: { type: "Point", coordinates: [46.194836, -123.415517] }
            },
            {
                type: "Feature",
                properties: { popupContent: "4. Beaver Army Terminal" },
                geometry: { type: "Point", coordinates: [46.207242, -123.179178] }
            },
            {
                type: "Feature",
                properties: { popupContent: "5. Longview" },
                geometry: { type: "Point", coordinates: [46.130687, -122.957263] }
            },
            {
                type: "Feature",
                properties: { popupContent: "6. St. Helens" },
                geometry: { type: "Point", coordinates: [45.859971, -122.793317] }
            },
            {
                type: "Feature",
                properties: { popupContent: "7. Vancouver" },
                geometry: { type: "Point", coordinates: [45.669511, -122.731214] }
            }
        ];

        const map = L.map(mapElementId, {
            closePopupOnClick: false
        }).setView([45.969123, -122.998000], 9);

        const myIcon = L.icon({
            iconUrl: "https://cdn.portofportland.com/images/marker-icon.png",
            iconRetinaUrl: "https://cdn.portofportland.com/images/marker-icon-2x.png",
            iconSize: [25, 39]
        });

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 10,
            minZoom: 8,
            attribution: "© <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>"
        }).addTo(map);

        // Add custom tile layer on top, if provided
        if (options.tileUrl) {
            L.tileLayer(options.tileUrl, {
                attribution: options.attribution ?? '© <a href="http://www.portofportland.com">Port of Portland</a>',
                tms: options.tms ?? false,
                opacity: options.opacity ?? 1
            }).addTo(map);
        }

        geojsonFeature.forEach(feature => {
            const [lat, lng] = feature.geometry.coordinates;

            L.marker([lat, lng], { icon: myIcon })
                .addTo(map)
                .bindPopup(feature.properties.popupContent, { autoClose: false })
                .openPopup();
        });


    }

    function initTimePicker() {
        flatpickr("#Time", {
            enableTime: true,
            noCalendar: true,
            dateFormat: "h:i K",
            defaultDate: new Date()
        });

        $("#Time")
            .addClass("form-control start-time")
            .removeClass("flatpickr-input");
    }

    function getRiverDepthForecast() {
        let date;
        let draft;

        const units = $("input[type='radio'][name='measure']:checked").val();

        if (units === "us") {
            date = $("#usDate").val();
            draft = $("#usDraft").val();
        } else {
            date = $("#metricDate").val();
            draft = $("#metricDraft").val();
        }

        $.ajax({
            url: "/Navigation/GetRiverStationsForecast",
            type: "GET",
            cache: false,
            beforeSend() {
                $("#submit").attr("disabled", "disabled").text("Sending...");
            },
            data: {
                departureDate: date,
                departureTime: $("#Time").val(),
                speed: $("#speed").val(),
                destination: $("#destination").val(),
                units,
                draft
            },
            success(data) {
                $(".list-results").html(data);
            },
            error(errorText, jqXHR, errorStatus) {
                console.log("Error");
                console.log(errorText, jqXHR, errorStatus);
            },
            complete() {
                $("#submit").attr("disabled", false).text("Submit");
            }
        });
    }

    function switchMeasurements() {
        const units = $("input[type='radio'][name='measure']:checked").val();

        $(".display-imperial").toggle(units === "us");
        $(".display-metric").toggle(units !== "us");
    }

    initMap();
    initTimePicker();
    switchMeasurements();

    $(document).on("click", "#submit", getRiverDepthForecast);
    $(document).on("change", ".measure", switchMeasurements);
}